/* @flow */

import React from 'react';
import { Modal, Icon, Header, Button, Message } from 'semantic-ui-react';

type Props = {
  loading: boolean,
  platform?: CatalogPlatform,
  onConfirm: () => void,
  onClose: () => void,
};

const getConfirmMessage = platform => {
  if (platform) {
    return (
      <Message icon>
        <Icon name="circle info" />
        <Message.Content>
          <Message.Header>
            {`Vous êtes sur le point de créer la plateforme ${platform.label}.`}
          </Message.Header>
          <p>
            {`
            La plateforme par défault ne sera plus utilisée sur cette page
            et ses données seront remplacées par celles fournies à partir de maintenant.`}
          </p>
          <p>{`Êtes-vous sûr(e) de vouloir créer la nouvelle plateforme ?`}</p>
        </Message.Content>
      </Message>
    );
  }

  return null;
};

const ConfirmPlatformChange = ({
  loading,
  platform,
  onConfirm,
  onClose,
}: Props) => {
  return (
    <Modal open={!!platform} onClose={onClose} closeIcon size="small">
      <Header content={`Création d'une nouvelle plateforme`} />
      <Modal.Content>
        {getConfirmMessage(platform)}
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={onClose}
          labelPosition="left"
          icon="close"
          content="Annuler"
        />
        <Button
          onClick={onConfirm}
          loading={loading}
          positive
          labelPosition="right"
          icon="check"
          content="Confirmer"
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmPlatformChange;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/ConfirmPlatformChange.js